// Single source of truth for "what roles exist and what kind are they."

export const ROLE = {
  MEDLINE_ADMINISTRATOR: "MedlineAdministrator",
  MEDLINE_STANDARD_USER: "MedlineStandardUser",
  MEDLINE_SUPPORT: "MedlineSupport",
  EXTERNAL_ADMINISTRATOR: "ExternalAdministrator",
  EXTERNAL_STANDARD_USER: "ExternalStandardUser",
  EXTERNAL_NE1_WOUND_EXPERT: "ExternalNE1WoundExpert",
  EXTERNAL_NE1_REVIEW: "ExternalNE1Review",
  EXTERNAL_NE1_ASSESSMENT: "ExternalNE1Assesment",
  EXTERNAL_NE1_READ_ONLY: "ExternalNE1ReadOnly",
} as const;

export type Role = (typeof ROLE)[keyof typeof ROLE];

export const ROLES = Object.values(ROLE) as Role[];

interface RoleMetadata {
  /** Medline-internal staff role vs. a customer-facing external role. */
  isExternal: boolean;
}

export const ROLE_METADATA: Record<Role, RoleMetadata> = {
  MedlineAdministrator: { isExternal: false },
  MedlineStandardUser: { isExternal: false },
  MedlineSupport: { isExternal: false },
  ExternalAdministrator: { isExternal: true },
  ExternalStandardUser: { isExternal: true },
  ExternalNE1WoundExpert: { isExternal: true },
  ExternalNE1Review: { isExternal: true },
  ExternalNE1Assesment: { isExternal: true },
  ExternalNE1ReadOnly: { isExternal: true },
};

export const isExternalRole = (role?: string | null): boolean =>
  !!role && !!ROLE_METADATA[role as Role]?.isExternal;
